import { render } from "./SectionsDetailTableStaticCilji.vue?vue&type=template&id=6104f3ec"
import script from "./SectionsDetailTableStaticCilji.vue?vue&type=script&lang=js"
export * from "./SectionsDetailTableStaticCilji.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__